import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("service/index"),
  
  store: (userData) => clientAuth.post('service/store', { json: userData }),
  

  show:(id)=>clientAuth.get('service/show/'+id),

  update:(id,userData)=>clientAuth.post('service/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`service/destroy/${id}`),
};